export enum HubTypeEnum{
  HubFull = 1,
  HubMt = 2
}
